/*
 * hp-card-swatch — a product card's colour swatches re-price and re-image the
 * card they sit in.
 *
 * ── ONE DELEGATED LISTENER, NOT A CUSTOM ELEMENT PER CARD ──────────────────
 * A card is a plain <div> rendered in six places (collection grid, search
 * results and panel, the 50/50, the scroller, recommendations), several of
 * which inject markup after load — the predictive-search panel replaces its
 * whole results list on every keystroke, and Section Rendering swaps grids
 * wholesale. A custom element would need upgrading in each of those paths;
 * a listener on the document catches every card that ever exists, including
 * ones added a second from now, and costs one bound function for the page.
 *
 * ── THE STATES ARE SERVER-RENDERED <template>s ─────────────────────────────
 * Nothing here formats money or builds a price. Each card carries one
 * <template class="hp-card__state"> per shown colour holding the REAL price
 * lockup that `hp-price` rendered, and this file copies it across. The
 * alternative — a JSON blob of amounts — would have put the money format and
 * the symbol/units/fraction split into JavaScript, which is a second
 * implementation of a snippet that already exists and drifts the first time the
 * lockup changes.
 *
 * The image is the exception, and only because an <img> cannot be cloned into
 * place without dropping the browser's already-decoded frame: `src`/`srcset`
 * ride on the template as data attributes and are assigned to the existing
 * element.
 */
(function () {
  const CARD = '[data-hp-card]';
  const INPUT = '.hp-card__swatch-input';

  function apply(card, value) {
    const state = card.querySelector(
      `template.hp-card__state[data-value="${CSS.escape(value)}"]`
    );
    if (!state) return;

    const prices = card.querySelector('[data-hp-card-prices]');
    if (prices) prices.innerHTML = state.innerHTML;

    /*
     * The RESTING image is only replaced when the chosen colour has one of its
     * own. A product can tag some colours and not others, and blanking the card
     * for the untagged ones would be worse than leaving the crop the merchant
     * chose — so no data attribute means no change.
     */
    const src = state.dataset.imageSrc;
    if (!src) return;

    const img = card.querySelector('.hp-card__image:not(.hp-card__image--hover)');
    if (!img || img.tagName !== 'IMG') return;

    /*
     * srcset FIRST, then src. Assigning src while a stale srcset is still on the
     * element lets the browser keep choosing from the old candidate list — the
     * src is only the fallback — so the new picture would not appear until a
     * resize happened to re-run selection.
     */
    if (state.dataset.imageSrcset) img.srcset = state.dataset.imageSrcset;
    img.src = src;
  }

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input || !input.matches?.(INPUT)) return;

    const card = input.closest(CARD);
    if (card) apply(card, input.value);
  });
})();
